// extracted by mini-css-extract-plugin
export default {"salonContainer":"CollageBlock_salonContainer__BkBrO","salonBlock":"CollageBlock_salonBlock__KBx3K"};